import React from "react"
import PropTypes from "prop-types"

import useProviderOrderForm from "../useProviderOrderForm"
import ProductOrderRow from "./ProductOrderRow"
import RequestedOrdersTable from "./RequestedOrdersTable"

const ProviderOrderCard = ({
  grupo,
  regionId,
  date,
  isSaving,
  editingItem,
  onCreateOrder,
  onUpdateItem,
  onDeleteItem,
  onStartEdit,
  onCancelEdit,
}) => {
  const form = useProviderOrderForm(grupo.rows, regionId, date)
  const { state, events } = form

  const provider = grupo.rows[0].provider
  const farm = grupo.rows[0].farm

  const disponibles = grupo.rows.filter(fila => fila.available_product > 0)

  const onSolicitar = async () => {
    const mensaje = form.validar()
    if (mensaje) {
      form.setError(mensaje)
      return
    }
    form.setError(null)

    const ok = await onCreateOrder(form.construirPayload(grupo.order))
    if (ok) events.reset()
  }

  return (
    <div className="ped-card ped-proveedor ped-anim">
      <div className="ped-proveedor-head">
        <span className="ped-proveedor-nombre">
          {provider?.company_name} — Punto de distribución {farm?.name}
        </span>
        {disponibles.length > 0 && (
          <span className="ped-pill">
            {disponibles.length}{" "}
            {disponibles.length === 1 ? "producto" : "productos"}
          </span>
        )}
      </div>

      {disponibles.length > 0 && (
        <>
          <div className="ped-proveedor-opciones">
            {farm?.local_delivery && (
              <div className="ped-opcion">
                <label
                  className="ped-opcion-label"
                  htmlFor={`ped-local-${farm.id}`}
                >
                  Recoger en granja
                </label>
                <input
                  id={`ped-local-${farm.id}`}
                  type="checkbox"
                  className="ped-check"
                  checked={state.pickLocal}
                  onChange={event =>
                    events.togglePickLocal(event.currentTarget.checked)
                  }
                />
                {state.pickLocal && <span className="ped-opcion-si">Sí</span>}
              </div>
            )}

            <div className="ped-opcion">
              <span className="ped-opcion-label">
                Hora deseada de recepción{" "}
                <span className="ped-opcion-nota">(Formato 24 hrs)</span>
              </span>
              <select
                className="ped-field ped-field-corto"
                aria-label="Fecha de recepción"
                value={state.fechaRecepcion}
                onChange={event => events.onChangeFecha(event.target.value)}
              >
                {state.fechas.map(opcion => (
                  <option key={opcion.value} value={opcion.value}>
                    {opcion.label}
                  </option>
                ))}
              </select>
              <select
                className="ped-field ped-field-hora"
                aria-label="Hora de recepción"
                value={state.horaRecepcion}
                onChange={event => events.onChangeHora(event.target.value)}
              >
                <option value="">— Hora —</option>
                {state.horas.map(opcion => (
                  <option key={opcion.value} value={opcion.value}>
                    {opcion.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {state.pickLocal && (
            <div className="ped-aviso">Se recoge en granja</div>
          )}

          {form.error && <div className="ped-error">{form.error}</div>}

          {disponibles.map(fila => (
            <ProductOrderRow
              key={fila.id}
              fila={fila}
              farm={farm}
              form={form}
            />
          ))}

          <div className="ped-proveedor-pie">
            <button
              type="button"
              className="ped-btn-save"
              disabled={isSaving}
              onClick={onSolicitar}
            >
              <i className="bx bx-cart" />
              {isSaving ? "Guardando…" : "Solicitar Pedido"}
            </button>
          </div>
        </>
      )}

      <RequestedOrdersTable
        order={grupo.order}
        isSaving={isSaving}
        editingItem={editingItem}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        onUpdateItem={onUpdateItem}
        onDeleteItem={onDeleteItem}
      />
    </div>
  )
}

ProviderOrderCard.propTypes = {
  grupo: PropTypes.object.isRequired,
  regionId: PropTypes.number,
  // fecha del pedido: base de las opciones de recepción
  date: PropTypes.string,
  isSaving: PropTypes.bool,
  editingItem: PropTypes.number,
  onCreateOrder: PropTypes.func.isRequired,
  onUpdateItem: PropTypes.func.isRequired,
  onDeleteItem: PropTypes.func.isRequired,
  onStartEdit: PropTypes.func.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
}

export default ProviderOrderCard
